export const maskString = (str: string | undefined): string => {
  if (!str) return ''
  const maskChar = '*'
  const minMaskedChars = 2 // Minimum characters to mask
  const startVisibleChars = 2
  const endVisibleChars = 2

  // Calculate length to mask
  const lengthToMask = Math.max(
    minMaskedChars,
    str.length - startVisibleChars - endVisibleChars,
  )

  // Get start, masked portion, and end
  const start = str.slice(0, startVisibleChars)
  const end = str.slice(-endVisibleChars)

  // Ensure enough masking even for short last names
  const masked = maskChar.repeat(lengthToMask)

  // Return the masked string
  return `${start}${masked}${end}`
}
